import CustomButton from '@perpay-web/components/base/CustomButton/CustomButton';
import Modal from '@perpay-web/components/base/Modal/Modal';
import CardCta from '@perpay-web/fintech/components/base/CardCta/CardCta';
import { useMount } from '@perpay-web/hooks/useMount';

import styles from './IneligibleStateModal.scss';

const IneligibleStateModal = ({ onClickEditAddress, onClose, onMount }) => {
    useMount(() => onMount());

    return (
        <Modal onClose={onClose} containerClassName={styles['modal-container']}>
            <div className={styles['ineligible-state-modal']}>
                <div className={styles['ineligible-state-modal__header']}>
                    Check your address
                </div>
                <div className={styles['ineligible-state-modal__body']}>
                    The Perpay Credit Card is not currently available in New
                    Hampshire. Please edit your address or check back later.
                </div>
                <CardCta
                    className={styles['ineligible-state-modal__button--edit']}
                    Component={CustomButton}
                    onClick={onClickEditAddress}
                >
                    Edit address
                </CardCta>
            </div>
        </Modal>
    );
};
export default IneligibleStateModal;
